module.exports = __webpack_public_path__ + "img/map_nobackground-w-pins.18f95dd2.png";